<template>

  <div class="myProjects" :class="{ embeddedRecordDetail: embedded }">

    <el-row v-if="!embedded" class="home">

      <el-col :span="16">

        <div>

          <el-breadcrumb separator="/">

            <el-breadcrumb-item>

              <clientNavSelector></clientNavSelector>

            </el-breadcrumb-item>

            <el-breadcrumb-item :to="{ path: `/${currentClientId}/my-projects` }">My Projects</el-breadcrumb-item>

            <el-breadcrumb-item :to="{ path: `/${currentClientId}/my-projects/${opWorksheet.projectPk}` }"> {{ opWorksheet.projectId }}</el-breadcrumb-item>

            <el-breadcrumb-item :to="{ path: `/${currentClientId}/my-projects/outpatient/${$route.params.ascTableId}` }">Record Detail</el-breadcrumb-item>

          </el-breadcrumb>

        </div>

      </el-col>

    </el-row>

    <el-row :gutter="30" v-if="loading">

      <el-col :span="24">

        <div v-loading="loading" element-loading-spinner="nucleus-loader"></div>

      </el-col>

    </el-row>

    <div class="coderContainerCard" :style="embedded ? 'min-height: 100px; margin-top: 0;' : 'min-height: 100px; margin-top: 10px;'">

      <el-row :gutter="30" v-if="!loading">

        <el-col :span="embedded ? 24 : 16">

          <!-- <el-button class="hiaButton pull-right" icon="el-icon-document" size="mini" @click="openWorksheet" plain round>Worksheet</el-button> -->

          <h5 v-if="!embedded">Audit Results</h5>

          <coderOutpatientDemographics style="margin: 0px 0px 20px 10px;" :worksheet="opWorksheet" :readOnly="readOnly" :embedded="embedded" class="collapseContent"></coderOutpatientDemographics>

          <el-collapse id="reviewAccordion" v-model="activeNames">

            <el-collapse-item name="dxs">

              <template slot="title">

                <span style="width: 100%;">

                  Diagnosis Codes

                  <span class="codeTotalHeader"> - {{ opWorksheet.dxs.length }} Total</span>

                </span>

              </template>

              <coderOutpatientDxs :worksheet="opWorksheet" :readOnly="readOnly" :embedded="embedded"></coderOutpatientDxs>

            </el-collapse-item>

            <el-collapse-item name="pxs" v-if="opWorksheet.outpatientGrouperId === 1">

              <template slot="title">

                <span style="width: 100%;">

                  Procedure Codes

                  <span class="codeTotalHeader"> - {{ opWorksheet.pxs.length }} Total</span>

                </span>

              </template>

              <coderOutpatientPxs :worksheet="opWorksheet" :readOnly="readOnly" :embedded="embedded"></coderOutpatientPxs>

            </el-collapse-item>

            <el-collapse-item name="cpts">

              <template slot="title">

                <span style="width: 100%;">

                  CPT Codes

                  <span class="codeTotalHeader"> - {{ opWorksheet.cpts.length }} Total</span>

                </span>

              </template>

              <coderOutpatientCpts :worksheet="opWorksheet" :readOnly="readOnly" :embedded="embedded"></coderOutpatientCpts>

            </el-collapse-item>

            <el-collapse-item title="Audit Findings" name="auditFindings">

              <coderOutpatientFindings :worksheet="opWorksheet"></coderOutpatientFindings>

            </el-collapse-item>

            <el-collapse-item v-if="embedded" name="responses" title="Responses">

              <div style="font-size: 13px; padding: 0px 0px 5px 10px;" v-if="opWorksheet.rebuttalsCompleted">Rebuttals Completed on {{ formatDate(opWorksheet.rebuttalsCompleted) }}. All Rebuttal Responses are locked.</div>

              <el-form ref="form" label-position="left" label-width="200px" size="mini" style="margin-top: 0px;margin-left: 10px;">

                <el-form-item v-if="opWorksheet.auditResult" size="mini" label="Audit Result">

                  <div style="margin: 6px 0px 0px 15px;">{{ opWorksheet.auditResult }}</div>

                </el-form-item>

                <el-form-item v-if="opWorksheet.responseNeeded" size="mini" label="Response Needed">

                  <div style="margin: 6px 0px 0px 15px;">{{ opWorksheet.responseNeeded }}</div>

                </el-form-item>

                <el-form-item v-if="opWorksheet.finalOutcome" size="mini" label="Final Outcome">

                  <div style="margin: 6px 0px 0px 15px;">{{ opWorksheet.finalOutcome }}</div>

                </el-form-item>

              </el-form>

              <coderOutpatientResponses :ascTableId="opWorksheet.ascTableId" :opWorksheet="opWorksheet" @dirty="unsavedChanges = $event" @GET_OP_WORKSHEET="GET_OP_WORKSHEET" :worksheet="opWorksheet" :readOnly="readOnly" :embedded="true"> </coderOutpatientResponses>

            </el-collapse-item>

          </el-collapse>

        </el-col>

        <el-col v-if="!embedded" :span="8" class="sticky">

          <h5 style="margin: 0px 0px 20px 0px">Responses</h5>

          <div style="font-size: 13px; padding: 0px 0px 5px 0px;" v-if="opWorksheet.rebuttalsCompleted">Rebuttals Completed on {{ formatDate(opWorksheet.rebuttalsCompleted) }}. All Rebuttal Responses are locked.</div>

          <el-form ref="form" id="form" label-position="left" label-width="200px" size="mini" :key="1" style="margin-top: 0px;margin-left: 10px;">

            <el-form-item v-if="opWorksheet.auditResult" size="mini" label="Audit Result">

              <div style="margin: 6px 0px 0px 15px;">{{ opWorksheet.auditResult }}</div>

            </el-form-item>

            <el-form-item v-if="opWorksheet.responseNeeded" size="mini" label="Response Needed">

              <div style="margin: 6px 0px 0px 15px;">{{ opWorksheet.responseNeeded }}</div>

            </el-form-item>

            <el-form-item v-if="opWorksheet.finalOutcome" size="mini" label="Final Outcome">

              <div style="margin: 6px 0px 0px 15px;">{{ opWorksheet.finalOutcome }}</div>

            </el-form-item>

          </el-form>

          <coderOutpatientResponses :ascTableId="opWorksheet.ascTableId" :opWorksheet="opWorksheet" @dirty="unsavedChanges = $event" @GET_OP_WORKSHEET="GET_OP_WORKSHEET" :worksheet="opWorksheet" :readOnly="readOnly"> </coderOutpatientResponses>

        </el-col>

      </el-row>

    </div>

  </div>

</template>

<script>

import { mapState, mapActions, mapMutations } from 'vuex'

import coderOutpatientDemographics from './coderOutpatientDemographics'

import coderOutpatientDxs from './coderOutpatientDxs'

import coderOutpatientCpts from './coderOutpatientCpts'

import coderOutpatientPxs from './coderOutpatientPxs'

import coderOutpatientFindings from './coderOutpatientFindings'

import coderOutpatientResponses from './coderOutpatientResponses'

import { format, parseISO } from 'date-fns'

export default {

  name: 'CoderOutpatientReview',

  props: {

    embedded: { type: Boolean, default: false },

    recordId: { type: [String, Number], default: null }

  },

  data: function() {
    return {

      loading: true,

      unsavedChanges: false,

      activeNames: ['dxs', 'pxs', 'cpts', 'auditFindings', 'responses'],

      dropdownsNeeded: ['ascPaymentIndicators']

    }
  },

  components: {

    coderOutpatientDemographics,

    coderOutpatientDxs,

    coderOutpatientCpts,

    coderOutpatientPxs,

    coderOutpatientFindings,

    coderOutpatientResponses

  },

  methods: {

    ...mapActions('myProjects/', ['GET_OP_WORKSHEET']),

    ...mapMutations('rebuttals/', ['SET_REBUTTALS']),

    ...mapActions('dropdowns', ['GET_DROPDOWNS']),

    getRecordId() {
      if (this.embedded && this.recordId != null) {
        return this.recordId
      }

      return this.$route.params.ascTableId
    },

    async getWorksheet() {
      const id = this.getRecordId()

      if (!id) {
        return
      }

      try {
        this.loading = true

        await Promise.all([this.GET_OP_WORKSHEET(id)])

        this.SET_REBUTTALS(this.opWorksheet.rebuttals)

        this.loading = false
      } catch (e) {
        this.loading = false

        this.$message({

          message: 'Error getting coder worksheet',

          type: 'error'

        })

        console.log(e)
      }
    },

    openWorksheet() {
      const cacheBuster = new Date().getTime()

      this.worksheetWindow = window.open(`/my-projects/outpatient/worksheet/${this.opWorksheet.ascTableId}?dt=${cacheBuster}&fullscreen=true`, 'worksheet', 'height=850,width=1600')
    },

    confirmLeave() {
      return window.confirm('Changes you made may not be saved.')
    },

    confirmStayInDirtyForm() {
      return this.unsavedChanges && !this.confirmLeave()
    },

    beforeWindowUnload(e) {
      if (this.confirmStayInDirtyForm()) {
        e.preventDefault()

        e.returnValue = ''
      }
    },

    formatDate(date) {
      return format(parseISO(date), 'MM/dd/yyyy')
    }

  },

  beforeRouteLeave(to, from, next) {
    if (this.confirmStayInDirtyForm()) {
      next(false)
    } else {
      next()
    }
  },

  created: async function() {
    this.loading = true

    await this.getWorksheet()

    this.loading = false

    if (!this.embedded) {
      window.addEventListener('beforeunload', this.beforeWindowUnload)
    }
  },

  beforeDestroy() {
    if (!this.embedded) {
      window.removeEventListener('beforeunload', this.beforeWindowUnload)
    }
  },

  computed: {

    ...mapState('user/', ['currentClient', 'currentClientName', 'currentClientId', 'clients', 'user']),

    ...mapState('myProjects/', ['opWorksheet']),

    readOnly() {
      return this.embedded || !!this.opWorksheet.rebuttalsCompleted
    }

  },

  watch: {

    recordId(val) {
      if (this.embedded && val != null) {
        this.getWorksheet()
      }
    }

  }

}

</script>

<style scoped>

h5 {

  margin: 0px 0px 20px 10px;

  font-size: 14px;

}

.sticky {

  position: sticky;

  top: 10px;

}

>>> .hiaTable tr td {

  border: none !important;

}

>>> .hiaTable th {

  border: none !important;

}

>>> .coderContainerCard {

  overflow: unset;

}

</style>
